import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useMutation, useQuery } from 'react-fetching-library';

import {
  getLinkedinInAccessToken,
  sendEmailForSubscripeParticipant,
} from '../../api/actions/selfRegistration/selfRegistration.actions';

import { Loader } from 'shared/components';

export const LinkedInContainer = () => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const code = queryParams.get('code') || '';

  const eventID = localStorage.getItem('eventId');
  const linkedInUser = JSON.parse(localStorage.getItem('LinkedInUser') || '{}');
  const { mutate: sendEmail } = useMutation(sendEmailForSubscripeParticipant);

  const { payload, loading } = useQuery(
    getLinkedinInAccessToken({ code, email: linkedInUser.email, eventId: eventID!, subtitle: linkedInUser.subtitle }),
  );

  const isLoading = loading;

  const sendLinkedUserEmail = async () => {
    if (payload) {
      await sendEmail(payload?.linkedinData?.participantId);
    }
  };

  useEffect(() => {
    if (!loading && payload?.linkedinData?.userInfo) {
      try {
        sendLinkedUserEmail();

        localStorage.removeItem('LinkedInUser');
        localStorage.removeItem('eventId');
        window.opener.postMessage({ source: 'linkedin-auth', payload }, '*');
        // window.close();
      } catch (err) {
        // Error handled silently
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, payload]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      {isLoading && <Loader fullScreen />}
    </div>
  );
};
